import { useAppSelector } from '../app/hooks';
import { ButtonBar } from '../controls/buttons';
import { useMessages2 } from '../hooks/useLanguage';
import { LoadingAnimation } from './loading-animation/loading-animation';
import { materialNamesSelector } from '../app/configurator-selectors';

import styles from './suggested-price.module.css';

export const SuggestedPrice = ({ price, currency, differencePrices, 
                                 className, isLoading, onClick }: {
    price?: number
    currency?: string
    className?: string
    isLoading?: boolean
    differencePrices?: number
    onClick?: () => void
}) => {

    const { messages } = useMessages2();
    const materialNames = useAppSelector(materialNamesSelector);

    const priceStr = price !== undefined ? formatPrice(price) : '';

    return <ButtonBar>
        <button className={`${styles.suggestedPrice} ${className ?? ''}`} onClick={onClick}>
            <p className={styles.spLabel}>{
                price === undefined ? 
                    messages?.this_configuration
                    :
                    messages?.Suggested_price_this_configuration }
            </p>                
            <p className={styles.mName}>
                {materialNames}
            </p>

           {!isLoading ?
                < >
                    {differencePrices != undefined && differencePrices != 0 ?
                        <span className={`${styles.differenceLabel} ${styles.hideTimer}`}>
                            { differencePrices > 0 && '+ '}{ differencePrices } { currency }
                        </span> : 
                        null
                    }
                    {
                        price !== undefined ? <>
                            <p className={styles.spPrice}>{ priceStr } </p>
                            <span className={styles.currency}>&nbsp;{ currency ? currency.toUpperCase() : '' }</span>
                        </>
                        : null
                    }
                </>
                : 
                <div className={styles.loaderContainer}>
                    <LoadingAnimation/>
                </div>
            }
        </button>
    </ButtonBar>
}

export function formatPrice(price: number) {
    const priceNumber = Math.floor(price);
    return new Intl.NumberFormat('nl-BE', {
        maximumFractionDigits: 0,

    }).format(priceNumber)
}